import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import OpenQuoteApiCall from 'src/service/OpenQuoteAPICall';
import { useQuoteDetailStore } from "../../../hooks/quote-detail";
import { Tooltip } from 'src/component/Tooltip';
import Helper from 'src/support/Helper';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import AuthConfig from "@system/config/auth";
import AuthRepository from 'src/repository/AuthRepository';
import System from 'src/helper/system';
import AxiosIndicatorRunTimeLoader from 'src/component/AxiosIndicatorRunTimeLoader';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const QuoteMessagePopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [status, SetStatus] = useState(false);
    const [{ QuoteMessagePopup }, { }, { }] = useDOMAttachToSystemStore();
    const [{ contactName, contactEmail, quoteRequestedDate }, { }, { }] = useQuoteDetailStore();
    const [{ quoteNumber }, { }, { }] = useQuoteDetailStore();
    const [messageError, setMessageError] = useState('')
    // const [hoverSubject, SetHoverSubject] = useState();
    const [pageLoader, setPageLoader] = useState(false);
    const c = System.getParams();
    const quoteProvisionalNumber = c.quoteProvisionalNumber;
    const qtStatus = c.__c_QuoteDetailTabList;
    //const subject = `In regard to Quote Number: ${quoteNumber} for ${props.data.single_quote_detail_item.status}`;
    // const subject = `Digital Quote Message from: ${quoteNumber} for ${props.data.single_quote_detail_item.status}`;
    // `Digital Quote message from ${contactName} - [customer account] about [ERP (SAP) material]`
    // const provisionalQtsubject = `In regard to Provisional Quote Number: ${quoteProvisionalNumber} for ${props.data.single_quote_detail_item.status}`;

    const detail = {
        "quoteInformation": {
            "quoteNumber": quoteNumber,
            "provisionalQuoteNumber": props.data.single_quote_detail_item?.provisionalQuoteNumber,
            "buyer": contactName,
            "status": props.data.single_quote_detail_item.status,
            "dateSubmitted": quoteRequestedDate && Helper.dateFormatFromString(quoteRequestedDate)
        },
        "partInformation": {
            "manufacturer": props.data.single_quote_detail_item.manufacturerName,
            "manufacturerPartNumber": props.data.single_quote_detail_item.ERPMFRPartNumber,
            "customerPartNumber": props.data.single_quote_detail_item.customerPartNumber
        },
        "subject": "",
        "message": "",
        "customerEmail": contactEmail, // sales reprentaive
        "userEmail": "" // logged in user
    };

    const [emailDetail, SetEmailDetail] = useState(detail);

    useEffect(() => {
        async function fetchHere() {
            const acctNumber = await AuthConfig.getAccountNumber();
            const acctName = await AuthConfig.getAccountName();
            // const hvrSubject = `${props.data.single_quote_detail_item.partNumber} for ${acctName} - ${acctNumber}`
            const msg = `Digital Quote message from ${contactName} - ${acctName} - ${acctNumber} about ${props.data.single_quote_detail_item.ERPMFRPartNumber}`
            // SetHoverSubject(hvrSubject);
            SetEmailDetail({ ...emailDetail, subject: msg })
        }
        fetchHere();
    }, []);

    useEffect(() => {
        if (QuoteMessagePopup) {
            SetStatus(true)
        }
    }, [QuoteMessagePopup]);

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const onValueChange = (field, value) => {
        if (value.trim().length > 255) {
            setMessageError('Maximum 255 characters allowed')
        } else {
            setMessageError('')
        }
        SetEmailDetail({ ...emailDetail, [field]: value })
    }

    // const renderTooltip = (props) => (
    //     <div>
    //         {hoverSubject}
    //     </div>
    // );

    const onSubmit = async () => {
        let err = false
        if (emailDetail.message && emailDetail.message.trim().length === 0) {
            setMessageError('Maximum 255 characters allowed');
            err = true
        }
        if (emailDetail.message.trim().length > 255) {
            setMessageError('Maximum 255 characters allowed');
            err = true
        }
        if (!err) {
            const emailId = await AuthConfig.getEmail();
            emailDetail.userEmail = emailId;
            const representativeEmailId = await new AuthRepository().getCustomerRepresentativeEmailIdList();
            emailDetail.customerEmail = representativeEmailId;
            // emailDetail.subject = hoverSubject;

            /**
             * CR # : 7987 
             * Change # : loader starts after send button click and After few seconds loader will stop
             * Change by # : Pankaj
             */
            setPageLoader(true);

            setTimeout(() => {
                setPageLoader(false);
                onHide();
                System.popup('ThankYouPopup', { isQuote: true }); // open pop-up before API Call    
            }, 3000)
            await new OpenQuoteApiCall().sendSubmittedQuoteEmail(emailDetail)
                .then((res) => {

                }).catch((e) => {
                    onHide(); // handling while error
                });
        }
    };

    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>
                <div className="avnet-modal modal-800">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×</button>
                        <div className="modal-header">

                            <h4 className="modal-title text-center">Quote Messages</h4>
                        </div>
                        <div className="modal-body">
                            <div className="row bs5">
                                <div className="col-6">
                                    <h5>QUOTE INFORMATION</h5>
                                    <div>
                                        <div>
                                            {qtStatus === 'PND' ?
                                                <><b>Web Quote Number:</b> {quoteProvisionalNumber} </> :
                                                <><b>Quote Number:</b> {emailDetail.quoteInformation.quoteNumber}</>}
                                        </div>
                                        <div><b>Buyer:</b> {emailDetail.quoteInformation.buyer}</div>
                                        <div><b>Status:</b> {emailDetail.quoteInformation.status}</div>
                                        <div><b>Date Submitted:</b> {quoteRequestedDate && Helper.dateFormatFromString(quoteRequestedDate)} </div>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <h5>PART INFORMATION</h5>
                                    <div>
                                        <div>
                                            <div><b>Manufacturer:</b> {emailDetail.partInformation.manufacturer}</div>
                                            <div><b>Manufacturer PN:</b> {emailDetail.partInformation.manufacturerPartNumber}     </div>
                                            {emailDetail.partInformation.customerPartNumber && <div><b>Customer PN:</b> {emailDetail.partInformation.customerPartNumber}</div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="alert bg-grey2 mt-4 border-0 rounded-0 p-3">
                                <span>
                                    <b>Subject:</b> {emailDetail.subject}
                                    {/* {qtStatus === 'PND' ? provisionalQtsubject : subject} */}

                                    {/* <Tooltip opener={() => (<span>...</span>)}
                                        content={() => (renderTooltip())}
                                    /> */}
                                </span>
                            </div>
                            <div className="form-group">
                                <textarea className="form-control" rows="5" id="message" placeholder="Type your message.."
                                    value={emailDetail.message}
                                    onChange={({ target: { value } }) => onValueChange('message', value)}
                                    maxLength="255"
                                />
                                <span className="d-block text-right mt-2">Characters remaining: {255 - emailDetail.message.trim().length > 0 ? 255 - emailDetail.message.trim().length : 0}/255</span>
                                <p className="error">{messageError.trim().length > 0 && messageError} </p>
                            </div>

                        </div>
                        <div className="modal-footer text-center">
                            {pageLoader && <AxiosIndicatorRunTimeLoader />}
                            {pageLoader === false &&
                                <>
                                    <button type="button" className="bs5 btn btn-secondary w145" data-dismiss="modal"
                                        onClick={() => {
                                            onHide()
                                        }}>Cancel</button>
                                    <button className="bs5 btn btn-primary w80"
                                        onClick={() => {
                                            onSubmit()
                                        }}>send</button>
                                </>
                            }
                        </div>
                    </div>
                </div>

            </Modal>

        </>
    )
}

export default QuoteMessagePopup;